export const reviewRowStyles = {
	row: {
		display: 'flex',
		flexDirection: 'column',
		gap: 0.5
	}
};
